import * as React from "react";
import type { SVGProps } from "react";
const SvgDataIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="data_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M768 85.333H256A170.667 170.667 0 0 0 85.333 256v512A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V256A170.667 170.667 0 0 0 768 85.333zM170.667 256A85.333 85.333 0 0 1 256 170.667h512A85.333 85.333 0 0 1 853.333 256v512A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V256zm554.666 256A42.667 42.667 0 1 0 640 512v213.333a42.667 42.667 0 1 0 85.333 0V512zM512 256a42.667 42.667 0 0 1 42.667 42.667v426.666a42.667 42.667 0 1 1-85.334 0V298.667A42.667 42.667 0 0 1 512 256zM384 426.667a42.667 42.667 0 0 0-85.333 0v298.666a42.667 42.667 0 1 0 85.333 0V426.667z"
    />
  </svg>
);
export default SvgDataIcon;
